module.exports = __webpack_public_path__ + "img/fimit-slider2.03c3173f.png";